import { FormBase } from "core/components";

export default class WoundDetailsForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: "debridementTypeId",
                    placeholder: "Select a debridement type",
                },
                {
                    name: "etiologyOtherDescription",
                    placeholder: "Enter Other",
                },
                {
                    name: "debridementDate",
                    placeholder: "Enter Date of Debridement",
                },
                {
                    name: "etiologyPressureStageId",
                    label: "Pressure Stage Type",
                    placeholder: "Select a pressure stage type",
                },
                {
                    name: "etiologyThicknessTypeId",
                    label: "Etiology Thickness Type",
                    placeholder: "Select a thickness type",
                },
                {
                    name: "length",
                    label: "Length (cm)",
                    placeholder: "Enter Length In CM",
                    type: "number",
                },
                {
                    name: "width",
                    label: "Width (cm)",
                    placeholder: "Enter Width In CM",
                    type: "number",
                },
                {
                    name: "depthUnknownTypeId",
                    label: "Wound Depth Type",
                    placeholder: "Select a wound depth type",
                },
                {
                    name: "depth",
                    label: "Depth (cm)",
                    placeholder: "Enter Depth",
                    type: "number",
                },
                {
                    name: "hasTunneling",
                    type: "bool",
                },
                {
                    name: "hasUndermining",
                    type: "bool",
                },
                {
                    name: "tunnelingSize",
                    label: "CM @",
                    placeholder: "Enter tunelling in cm",
                    type: "number",
                },
                {
                    name: "tunnelingPosition",
                    label: "O'clock",
                    placeholder: "O'clock",
                    type: "number",
                },
                {
                    name: "underminingSize",
                    label: "CM @",
                    placeholder: "Enter tunelling in cm",
                    type: "number",
                },
                {
                    name: "underminingStartPosition",
                    label: "O'clock",
                    placeholder: "O'clock",
                    type: "number",
                },
                {
                    name: "underminingEndPosition",
                    label: "O'clock",
                    placeholder: "O'clock",
                    type: "number",
                },
                {
                    name: "location",
                    placeholder: "Enter Location",
                    type: "textarea",
                    rules: "string",
                },
                {
                    name: "exudateTypeId",
                    placeholder: "Select a exudate type",
                },
                {
                    name: "diagnosisCodes",
                    placeholder: "Select diagnosis codes",
                },
                {
                    name: "woundOrderId",
                    label: "Wound Order",
                },
                {
                    name: "modificationTypeId",
                    label: "Modification Type",
                    placeholder: "Select a modification type",
                },
                {
                    name: "noModificationReason",
                    label: "No modification reason",
                },
                {
                    name: "id",
                    label: "Wound Id",
                },
            ],
        };
    }
}
